var cov_134pemt0l6 = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Pagination/Links.tsx",
      hash = "ec4acc1ab592bc2c23baa3843975ea6d4fd5db1a",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Pagination/Links.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 21
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 19
        },
        end: {
          line: 22,
          column: 1
        }
      },
      "2": {
        start: {
          line: 17,
          column: 14
        },
        end: {
          line: 17,
          column: 21
        }
      },
      "3": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 20,
          column: 3
        }
      },
      "4": {
        start: {
          line: 19,
          column: 4
        },
        end: {
          line: 19,
          column: 33
        }
      },
      "5": {
        start: {
          line: 21,
          column: 2
        },
        end: {
          line: 21,
          column: 30
        }
      },
      "6": {
        start: {
          line: 28,
          column: 67
        },
        end: {
          line: 28,
          column: 77
        }
      },
      "7": {
        start: {
          line: 30,
          column: 4
        },
        end: {
          line: 30,
          column: 49
        }
      },
      "8": {
        start: {
          line: 30,
          column: 21
        },
        end: {
          line: 30,
          column: 49
        }
      },
      "9": {
        start: {
          line: 32,
          column: 16
        },
        end: {
          line: 32,
          column: 43
        }
      },
      "10": {
        start: {
          line: 33,
          column: 18
        },
        end: {
          line: 33,
          column: 20
        }
      },
      "11": {
        start: {
          line: 35,
          column: 15
        },
        end: {
          line: 35,
          column: 45
        }
      },
      "12": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 38,
          column: 5
        }
      },
      "13": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 37,
          column: 14
        }
      },
      "14": {
        start: {
          line: 39,
          column: 4
        },
        end: {
          line: 39,
          column: 23
        }
      },
      "15": {
        start: {
          line: 40,
          column: 4
        },
        end: {
          line: 48,
          column: 5
        }
      },
      "16": {
        start: {
          line: 41,
          column: 6
        },
        end: {
          line: 41,
          column: 21
        }
      },
      "17": {
        start: {
          line: 42,
          column: 6
        },
        end: {
          line: 42,
          column: 25
        }
      },
      "18": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 45,
          column: 7
        }
      },
      "19": {
        start: {
          line: 44,
          column: 8
        },
        end: {
          line: 44,
          column: 16
        }
      },
      "20": {
        start: {
          line: 47,
          column: 6
        },
        end: {
          line: 47,
          column: 31
        }
      },
      "21": {
        start: {
          line: 50,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "22": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 19
        }
      },
      "23": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 57,
          column: 5
        }
      },
      "24": {
        start: {
          line: 54,
          column: 6
        },
        end: {
          line: 54,
          column: 19
        }
      },
      "25": {
        start: {
          line: 55,
          column: 11
        },
        end: {
          line: 57,
          column: 5
        }
      },
      "26": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 56,
          column: 22
        }
      },
      "27": {
        start: {
          line: 59,
          column: 4
        },
        end: {
          line: 61,
          column: 5
        }
      },
      "28": {
        start: {
          line: 60,
          column: 6
        },
        end: {
          line: 60,
          column: 19
        }
      },
      "29": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 67,
          column: 5
        }
      },
      "30": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 64,
          column: 25
        }
      },
      "31": {
        start: {
          line: 65,
          column: 11
        },
        end: {
          line: 67,
          column: 5
        }
      },
      "32": {
        start: {
          line: 66,
          column: 6
        },
        end: {
          line: 66,
          column: 22
        }
      },
      "33": {
        start: {
          line: 69,
          column: 4
        },
        end: {
          line: 71,
          column: 5
        }
      },
      "34": {
        start: {
          line: 70,
          column: 6
        },
        end: {
          line: 70,
          column: 21
        }
      },
      "35": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 25
        }
      },
      "36": {
        start: {
          line: 77,
          column: 70
        },
        end: {
          line: 77,
          column: 80
        }
      },
      "37": {
        start: {
          line: 78,
          column: 27
        },
        end: {
          line: 78,
          column: 42
        }
      },
      "38": {
        start: {
          line: 80,
          column: 4
        },
        end: {
          line: 109,
          column: 5
        }
      },
      "39": {
        start: {
          line: 84,
          column: 10
        },
        end: {
          line: 90,
          column: 11
        }
      },
      "40": {
        start: {
          line: 85,
          column: 12
        },
        end: {
          line: 89,
          column: 13
        }
      },
      "41": {
        start: {
          line: 91,
          column: 25
        },
        end: {
          line: 91,
          column: 35
        }
      },
      "42": {
        start: {
          line: 92,
          column: 21
        },
        end: {
          line: 92,
          column: 61
        }
      },
      "43": {
        start: {
          line: 93,
          column: 10
        },
        end: {
          line: 93,
          column: 32
        }
      },
      "44": {
        start: {
          line: 93,
          column: 24
        },
        end: {
          line: 93,
          column: 32
        }
      },
      "45": {
        start: {
          line: 94,
          column: 10
        },
        end: {
          line: 94,
          column: 36
        }
      },
      "46": {
        start: {
          line: 94,
          column: 26
        },
        end: {
          line: 94,
          column: 36
        }
      },
      "47": {
        start: {
          line: 95,
          column: 10
        },
        end: {
          line: 105,
          column: 11
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 19
          },
          end: {
            line: 16,
            column: 20
          }
        },
        loc: {
          start: {
            line: 16,
            column: 40
          },
          end: {
            line: 22,
            column: 1
          }
        },
        line: 16
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 27,
            column: 2
          },
          end: {
            line: 27,
            column: 3
          }
        },
        loc: {
          start: {
            line: 27,
            column: 13
          },
          end: {
            line: 74,
            column: 3
          }
        },
        line: 27
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 76,
            column: 2
          },
          end: {
            line: 76,
            column: 3
          }
        },
        loc: {
          start: {
            line: 76,
            column: 11
          },
          end: {
            line: 110,
            column: 3
          }
        },
        line: 76
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 83,
            column: 19
          },
          end: {
            line: 83,
            column: 20
          }
        },
        loc: {
          start: {
            line: 83,
            column: 24
          },
          end: {
            line: 106,
            column: 9
          }
        },
        line: 83
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        }, {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 20,
            column: 3
          }
        }],
        line: 18
      },
      "1": {
        loc: {
          start: {
            line: 18,
            column: 6
          },
          end: {
            line: 18,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 18,
            column: 7
          },
          end: {
            line: 18,
            column: 13
          }
        }, {
          start: {
            line: 18,
            column: 17
          },
          end: {
            line: 18,
            column: 20
          }
        }, {
          start: {
            line: 18,
            column: 26
          },
          end: {
            line: 18,
            column: 33
          }
        }, {
          start: {
            line: 18,
            column: 37
          },
          end: {
            line: 18,
            column: 41
          }
        }],
        line: 18
      },
      "2": {
        loc: {
          start: {
            line: 28,
            column: 38
          },
          end: {
            line: 28,
            column: 62
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 28,
            column: 45
          },
          end: {
            line: 28,
            column: 62
          }
        }],
        line: 28
      },
      "3": {
        loc: {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 49
          }
        }, {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 30,
            column: 49
          }
        }],
        line: 30
      },
      "4": {
        loc: {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        }, {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 38,
            column: 5
          }
        }],
        line: 36
      },
      "5": {
        loc: {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 48,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 48,
            column: 5
          }
        }, {
          start: {
            line: 40,
            column: 4
          },
          end: {
            line: 48,
            column: 5
          }
        }],
        line: 40
      },
      "6": {
        loc: {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        }, {
          start: {
            line: 43,
            column: 6
          },
          end: {
            line: 45,
            column: 7
          }
        }],
        line: 43
      },
      "7": {
        loc: {
          start: {
            line: 47,
            column: 15
          },
          end: {
            line: 47,
            column: 31
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 47,
            column: 26
          },
          end: {
            line: 47,
            column: 27
          }
        }, {
          start: {
            line: 47,
            column: 30
          },
          end: {
            line: 47,
            column: 31
          }
        }],
        line: 47
      },
      "8": {
        loc: {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }, {
          start: {
            line: 50,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }],
        line: 50
      },
      "9": {
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        }, {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        }],
        line: 53
      },
      "10": {
        loc: {
          start: {
            line: 55,
            column: 11
          },
          end: {
            line: 57,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 55,
            column: 11
          },
          end: {
            line: 57,
            column: 5
          }
        }, {
          start: {
            line: 55,
            column: 11
          },
          end: {
            line: 57,
            column: 5
          }
        }],
        line: 55
      },
      "11": {
        loc: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        }, {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 67,
            column: 5
          }
        }],
        line: 63
      },
      "12": {
        loc: {
          start: {
            line: 65,
            column: 11
          },
          end: {
            line: 67,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 65,
            column: 11
          },
          end: {
            line: 67,
            column: 5
          }
        }, {
          start: {
            line: 65,
            column: 11
          },
          end: {
            line: 67,
            column: 5
          }
        }],
        line: 65
      },
      "13": {
        loc: {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 71,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 71,
            column: 5
          }
        }, {
          start: {
            line: 69,
            column: 4
          },
          end: {
            line: 71,
            column: 5
          }
        }],
        line: 69
      },
      "14": {
        loc: {
          start: {
            line: 77,
            column: 31
          },
          end: {
            line: 77,
            column: 55
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 77,
            column: 38
          },
          end: {
            line: 77,
            column: 55
          }
        }],
        line: 77
      },
      "15": {
        loc: {
          start: {
            line: 84,
            column: 10
          },
          end: {
            line: 90,
            column: 11
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 10
          },
          end: {
            line: 90,
            column: 11
          }
        }, {
          start: {
            line: 84,
            column: 10
          },
          end: {
            line: 90,
            column: 11
          }
        }],
        line: 84
      },
      "16": {
        loc: {
          start: {
            line: 92,
            column: 21
          },
          end: {
            line: 92,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 92,
            column: 30
          },
          end: {
            line: 92,
            column: 44
          }
        }, {
          start: {
            line: 92,
            column: 47
          },
          end: {
            line: 92,
            column: 61
          }
        }],
        line: 92
      },
      "17": {
        loc: {
          start: {
            line: 93,
            column: 10
          },
          end: {
            line: 93,
            column: 32
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 93,
            column: 10
          },
          end: {
            line: 93,
            column: 32
          }
        }, {
          start: {
            line: 93,
            column: 10
          },
          end: {
            line: 93,
            column: 32
          }
        }],
        line: 93
      },
      "18": {
        loc: {
          start: {
            line: 94,
            column: 10
          },
          end: {
            line: 94,
            column: 36
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 10
          },
          end: {
            line: 94,
            column: 36
          }
        }, {
          start: {
            line: 94,
            column: 10
          },
          end: {
            line: 94,
            column: 36
          }
        }],
        line: 94
      },
      "19": {
        loc: {
          start: {
            line: 100,
            column: 38
          },
          end: {
            line: 100,
            column: 73
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 100,
            column: 47
          },
          end: {
            line: 100,
            column: 58
          }
        }, {
          start: {
            line: 100,
            column: 61
          },
          end: {
            line: 100,
            column: 73
          }
        }],
        line: 100
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0, 0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Pagination/Links.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import icons from '../icons';
import { paginationClass } from './styles';
import Item from './Item';
import Prev from './Prev';
import Next from './Next';
import { isRTL } from '../config';
import { getDirectionClass } from '../utils/classname';
var DefaultValue = (cov_134pemt0l6.s[0]++, {
  span: 5,
  text: {}
});
cov_134pemt0l6.s[1]++;

var renderIcon = function renderIcon(isPrev) {
  cov_134pemt0l6.f[0]++;
  var rtl = (cov_134pemt0l6.s[2]++, isRTL());
  cov_134pemt0l6.s[3]++;

  if ((cov_134pemt0l6.b[1][0]++, isPrev) && (cov_134pemt0l6.b[1][1]++, rtl) || (cov_134pemt0l6.b[1][2]++, !isPrev) && (cov_134pemt0l6.b[1][3]++, !rtl)) {
    cov_134pemt0l6.b[0][0]++;
    cov_134pemt0l6.s[4]++;
    return icons.AngleDoubleRight;
  } else {
    cov_134pemt0l6.b[0][1]++;
  }

  cov_134pemt0l6.s[5]++;
  return icons.AngleDoubleLeft;
};

var Links =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Links, _PureComponent);

  var _super = _createSuper2(Links);

  function Links() {
    _classCallCheck(this, Links);

    return _super.apply(this, arguments);
  }

  _createClass(Links, [{
    key: "getLinks",
    value: function getLinks() {
      cov_134pemt0l6.f[1]++;

      var _ref = (cov_134pemt0l6.s[6]++, this.props),
          current = _ref.current,
          total = _ref.total,
          pageSize = _ref.pageSize,
          _ref$span = _ref.span,
          span = _ref$span === void 0 ? (cov_134pemt0l6.b[2][0]++, DefaultValue.span) : _ref$span;

      cov_134pemt0l6.s[7]++;

      if (total === 0) {
        cov_134pemt0l6.b[3][0]++;
        cov_134pemt0l6.s[8]++;
        return {
          links: [],
          max: 0
        };
      } else {
        cov_134pemt0l6.b[3][1]++;
      }

      var max = (cov_134pemt0l6.s[9]++, Math.ceil(total / pageSize));
      var links = (cov_134pemt0l6.s[10]++, []);
      var right;
      var left = (cov_134pemt0l6.s[11]++, current - Math.floor(span / 2));
      cov_134pemt0l6.s[12]++;

      if (left < 3) {
        cov_134pemt0l6.b[4][0]++;
        cov_134pemt0l6.s[13]++;
        left = 3;
      } else {
        cov_134pemt0l6.b[4][1]++;
      }

      cov_134pemt0l6.s[14]++;
      right = left + span;
      cov_134pemt0l6.s[15]++;

      if (right + 1 >= max) {
        cov_134pemt0l6.b[5][0]++;
        cov_134pemt0l6.s[16]++;
        right = max - 1;
        cov_134pemt0l6.s[17]++;
        left = right - span;
        cov_134pemt0l6.s[18]++;

        if (left < 1) {
          cov_134pemt0l6.b[6][0]++;
          cov_134pemt0l6.s[19]++;
          left = 1;
        } else {
          cov_134pemt0l6.b[6][1]++;
        }
      } else {
        cov_134pemt0l6.b[5][1]++;
        cov_134pemt0l6.s[20]++;
        right -= left > 1 ? (cov_134pemt0l6.b[7][0]++, 1) : (cov_134pemt0l6.b[7][1]++, 0);
      }

      cov_134pemt0l6.s[21]++;

      if (left > 1) {
        cov_134pemt0l6.b[8][0]++;
        cov_134pemt0l6.s[22]++;
        links.push(1);
      } else {
        cov_134pemt0l6.b[8][1]++;
      }

      cov_134pemt0l6.s[23]++;

      if (left === 3) {
        cov_134pemt0l6.b[9][0]++;
        cov_134pemt0l6.s[24]++;
        links.push(2);
      } else {
        cov_134pemt0l6.b[9][1]++;
        cov_134pemt0l6.s[25]++;

        if (left > 3) {
          cov_134pemt0l6.b[10][0]++;
          cov_134pemt0l6.s[26]++;
          links.push('<<');
        } else {
          cov_134pemt0l6.b[10][1]++;
        }
      }

      cov_134pemt0l6.s[27]++;

      for (var i = left; i < right + 1; i++) {
        cov_134pemt0l6.s[28]++;
        links.push(i);
      }

      cov_134pemt0l6.s[29]++;

      if (right === max - 2) {
        cov_134pemt0l6.b[11][0]++;
        cov_134pemt0l6.s[30]++;
        links.push(max - 1);
      } else {
        cov_134pemt0l6.b[11][1]++;
        cov_134pemt0l6.s[31]++;

        if (right < max - 1) {
          cov_134pemt0l6.b[12][0]++;
          cov_134pemt0l6.s[32]++;
          links.push('>>');
        } else {
          cov_134pemt0l6.b[12][1]++;
        }
      }

      cov_134pemt0l6.s[33]++;

      if (right < max) {
        cov_134pemt0l6.b[13][0]++;
        cov_134pemt0l6.s[34]++;
        links.push(max);
      } else {
        cov_134pemt0l6.b[13][1]++;
      }

      cov_134pemt0l6.s[35]++;
      return {
        links: links,
        max: max
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      cov_134pemt0l6.f[2]++;

      var _ref2 = (cov_134pemt0l6.s[36]++, this.props),
          current = _ref2.current,
          onChange = _ref2.onChange,
          _ref2$span = _ref2.span,
          span = _ref2$span === void 0 ? (cov_134pemt0l6.b[14][0]++, DefaultValue.span) : _ref2$span,
          disabled = _ref2.disabled;

      var _ref3 = (cov_134pemt0l6.s[37]++, this.getLinks()),
          links = _ref3.links,
          max = _ref3.max;

      cov_134pemt0l6.s[38]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: paginationClass('links', getDirectionClass('section')),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 81,
            columnNumber: 7
          }
        },
        /*#__PURE__*/
        React.createElement(Prev, Object.assign({}, this.props, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 82,
            columnNumber: 9
          }
        })), links.map(function (p) {
          cov_134pemt0l6.f[3]++;
          cov_134pemt0l6.s[39]++;

          if (typeof p === 'number') {
            cov_134pemt0l6.b[15][0]++;
            cov_134pemt0l6.s[40]++;
            return (
              /*#__PURE__*/
              React.createElement(Item, {
                key: p,
                disabled: disabled,
                isCurrent: current === p,
                page: p,
                onClick: onChange,
                __self: _this,
                __source: {
                  fileName: _jsxFileName,
                  lineNumber: 86,
                  columnNumber: 15
                }
              }, p)
            );
          } else {
            cov_134pemt0l6.b[15][1]++;
          }

          var isPrev = (cov_134pemt0l6.s[41]++, p === '<<');
          var page = (cov_134pemt0l6.s[42]++, isPrev ? (cov_134pemt0l6.b[16][0]++, current - span) : (cov_134pemt0l6.b[16][1]++, current + span));
          cov_134pemt0l6.s[43]++;

          if (page < 1) {
            cov_134pemt0l6.b[17][0]++;
            cov_134pemt0l6.s[44]++;
            page = 1;
          } else {
            cov_134pemt0l6.b[17][1]++;
          }

          cov_134pemt0l6.s[45]++;

          if (page > max) {
            cov_134pemt0l6.b[18][0]++;
            cov_134pemt0l6.s[46]++;
            page = max;
          } else {
            cov_134pemt0l6.b[18][1]++;
          }

          cov_134pemt0l6.s[47]++;
          return (
            /*#__PURE__*/
            React.createElement(Item, {
              key: p,
              disabled: disabled,
              page: page,
              className: "no-border ".concat(isPrev ? (cov_134pemt0l6.b[19][0]++, 'more-left') : (cov_134pemt0l6.b[19][1]++, 'more-right')),
              onClick: onChange,
              __self: _this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 96,
                columnNumber: 13
              }
            }, renderIcon(isPrev))
          );
        }),
        /*#__PURE__*/
        React.createElement(Next, Object.assign({}, this.props, {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 107,
            columnNumber: 9
          }
        })))
      );
    }
  }]);

  return Links;
}(PureComponent);

Links.defaultProps = DefaultValue;
export default Links;